import $api from '../http'
import SchoolApiTypes from './schoolApiTypes'

// Запросы к методам работы с пользователями
const schoolRequests = {
	// Получение списка школ администратора
	getSchoolsByUser(userId: number | string) {
		return $api.get<SchoolApiTypes.GetSchoolsByUser>(
			'/api/schools/by-user/' + userId
		)
	},

	// Получение школы
	getSchool(schoolId: number | string) {
		return $api.get<SchoolApiTypes.GetSchool>('/api/schools/' + schoolId)
	},

	// Получение текущей школы
	getCurrentSchool() {
		return $api.get<SchoolApiTypes.GetCurrentSchool>('/api/schools/current')
	},

	// Обновление данных школы
	updateSchool(dto: SchoolApiTypes.UpdateSchoolDto) {
		return $api.put<SchoolApiTypes.UpdateSchool>('/api/schools', dto)
	},

	// Удаление пользователя (не действует на администратора)
	deleteUser(userId: string | number) {
		return $api.delete<SchoolApiTypes.DeleteUser>(
			'/api/schools/user/' + userId
		)
	},
}

export default schoolRequests
